import React, { FC } from "react";
import { PayoutInformationContextProvider } from "./context";
import { PayoutInformationPage } from "./payout-information-page";

export const PayoutInformationPageWrapper: FC = () => (
    <PayoutInformationContextProvider>
        <PayoutInformationPage />
    </PayoutInformationContextProvider>
);
